(function () {
  function syncCollectionCardVariantImage(input) {
    if (!input) return;

    var mediaId = input.dataset.optionMediaId;
    if (!mediaId) return;

    var productCard = input.closest('product-card');
    if (!productCard) return;

    var attempts = 0;
    var maxAttempts = 30;

    function trySync() {
      attempts += 1;

      var targetSlide = productCard.querySelector(
        'slideshow-slide[slide-id="' + mediaId + '"]'
      );

      if (!targetSlide) {
        if (attempts < maxAttempts) setTimeout(trySync, 100);
        return;
      }

      var scroller = targetSlide.closest('slideshow-slides');
      if (!scroller) {
        if (attempts < maxAttempts) setTimeout(trySync, 100);
        return;
      }

      var isHidden = targetSlide.hasAttribute('hidden');
      var left = targetSlide.offsetLeft;

      if (isHidden || typeof left !== 'number') {
        if (attempts < maxAttempts) setTimeout(trySync, 100);
        return;
      }

      scroller.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }

    setTimeout(trySync, 100);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest(
      'swatches-variant-picker-component input[type="radio"]'
    );
    if (!input) return;

    syncCollectionCardVariantImage(input);
  }, true);
})();